export default __webpack_public_path__ + "static/media/bellSuport.a3dd13b6.wav";